import * as React from 'react';

import { cn } from '../../lib/utils';

const TypographyH5 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <h5
    ref={ref}
    className={cn('scroll-m-20 text-display-xs font-regular', className)}
    {...props}
  />
));
TypographyH5.displayName = 'TypographyH5';

export { TypographyH5 };
